export default __webpack_public_path__ + "static/media/loading.f986ff88.gif";